var map = {
	"./aman-nyaman.png": "jJFm",
	"./basic-notext.png": "bdq+",
	"./friendly.png": "fmr6",
	"./kapasitas-stargroup.png": "VpkW",
	"./kapasitas-starvan.png": "2Jw+",
	"./kapasitas-starx.png": "ZUbk",
	"./kemudahan-pembayaran.png": "0RZM",
	"./notext-stargroup.png": "Bjtc",
	"./notext-starpick.png": "dixW",
	"./notext-starroad.png": "974+",
	"./notext-startrip.png": "DvqY",
	"./notext-startripgroup.png": "NAvO",
	"./notext-startripvan.png": "P6bq",
	"./notext-startripx.png": "E+sO",
	"./notext-starvan.png": "nEwb",
	"./notext-starx.png": "RQEC",
	"./stargroup.png": "OzjB",
	"./starpick.png": "H1li",
	"./starroad.png": "jyl6",
	"./startrip.png": "l8yR",
	"./startripgroup.png": "b+zh",
	"./startripvan.png": "tFym",
	"./startripx.png": "4Bkm",
	"./starvan.png": "lx29",
	"./starx.png": "pMul",
	"./tarif-pasti.png": "REcJ",
	"./tepat-waktu.png": "yeZC",
	"./trip-notext.png": "2K/Q",
	"./waktu-fleksibel.png": "nTtq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/4Z6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services ^\.\/.*$
// module id = /4Z6
// module chunks = 1